
// Scroll to critic reviews section
$(".criticReviewsLink").on("click", function(e){
  e.preventDefault();
  let scrollToElem = $($(this).attr("href"));
  if(scrollToElem.length > 0) {
    $([document.documentElement, document.body]).animate({
      scrollTop: scrollToElem.offset().top - 140
    }, 1000);
  }
});